import { render, staticRenderFns } from "./CloudFooter.vue?vue&type=template&id=6df646ce&scoped=true"
import script from "./CloudFooter.vue?vue&type=script&lang=js"
export * from "./CloudFooter.vue?vue&type=script&lang=js"
import style0 from "./CloudFooter.vue?vue&type=style&index=0&id=6df646ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df646ce",
  null
  
)

export default component.exports